<template>
<div class="row q-mx-md">
  <q-list :class="`col-md-${12 / rows}`"
          v-for="(row, index) in itemRows" :key="`row-${index}`">
    <q-item v-for="item in row"
            :key="`option-${item[optionValue]}`">
      <q-item-section>
        <q-checkbox :modelValue="modelValue"
                    :color="error ? 'negative' : undefined"
                    :keep-color="error"
                    :id="`${name}-option-${item[optionValue]}`.replaceAll(/[^a-z0-9\-_]/gi, '')"
                    @update:modelValue="$emit('update:modelValue', $event)"
                    :val="item[optionValue]"
                    :name="name">
          <q-item-label>
            {{ item[optionLabel] }}
          </q-item-label>
          <q-item-label caption v-if="item[optionCaption]">
            {{ item[optionCaption] }}
          </q-item-label>
        </q-checkbox>
      </q-item-section>
    </q-item>
  </q-list>
  <div class="col-md-6">
    <div role="alert" v-if="error" class="text-negative">
      {{ errorMessage }}
    </div>
  </div>
  <div class="col-md-6 q-mt-md"
       :class="{'text-right':!$isMobile}">
    <q-btn
        outline
        class="q-mr-sm"
        :class="{'q-ml-md': !$isMobile}"
        color="primary"
        :disable="modelValue.length === items.length"
        @click="selectAll">Selecteer alles
    </q-btn>
    <q-btn
        outline
        color="primary"
        :class="{'q-mr-md': !$isMobile}"
        :disable="modelValue.length === 0"
        @click="deselectAll">Deselecteer alles
    </q-btn>
  </div>
</div>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  props: {
    items: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    optionValue: {
      type: String,
      default: 'id',
    },
    optionLabel: {
      type: String,
      default: 'title',
    },
    optionCaption: {
      type: String,
      default: 'description',
    },
    rows: {
      type: Number,
      default: 2,
    },
    error: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
    },
  },
  computed: {
    itemRows () {
      return this.items.reduce((rows, item, index) => {
        const row = index % this.rows
        if (!rows[row]) rows[row] = []
        rows[row].push(item)
        return rows
      }, [])
    },
  },
  methods: {
    selectAll () {
      this.$emit('update:modelValue', this.items.map((item) => {
        return item[this.optionValue]
      }))
    },
    deselectAll () {
      this.$emit('update:modelValue', [])
    },
  },
}
</script>
